import mobileMenu from './modules/mobile-menu';
import toggleSearch from './modules/search';
import {
    swiperHeroBanner,
    swiperDataBenefits,
    swiperDataIndustries,
    swiperDataSupport,
    swiperFeedback,
    swiperTeam,
    swiperPhotoGallery
} from './modules/swiper';
import tabs from './modules/tabs';
import fixedHeader from './modules/header';
import selectInit from './modules/select';
import newsCard from './modules/news-card';
import scrollPageNavigation from './modules/scroll-page-nav';
import pluralize from './modules/pluralize';
import stylizationInput from './modules/stylization-input';
import popup from './modules/popup';
import inputMask from './modules/inputMask';
import formsValidate from './modules/simpleValidate';
import mobileMenuFooter from './modules/footer';
import { setVh } from './helpers/helpers';
import subMobileMenu from './modules/subMobileMenu';

document.addEventListener('DOMContentLoaded', () => {
    mobileMenu();
    toggleSearch();
    swiperFeedback();
    tabs();
    selectInit();
    newsCard();
    scrollPageNavigation();
    swiperTeam();
    swiperPhotoGallery();
    swiperDataSupport();
    swiperDataBenefits();
    swiperDataIndustries();
    pluralize();
    stylizationInput();
    popup();
    inputMask();
    formsValidate();
    setVh();
    mobileMenuFooter();
    subMobileMenu();
});

// eslint-disable-next-line func-names
window.onload = function () {
    fixedHeader();
    swiperHeroBanner();
    const preloader = document.getElementById('preloader');
    if (preloader) {
        setTimeout(() => {
            preloader.style.display = 'none';
        }, 100);
    }
};

window.addEventListener('resize', () => {
    setVh();
    newsCard();
    scrollPageNavigation();
    swiperHeroBanner();
    swiperDataIndustries();
    swiperDataBenefits();
    mobileMenuFooter();
    subMobileMenu();
    fixedHeader();
});
